import React from 'react';

const Financial = () => <div>Financial</div>;

export default Financial;
